import React, { FunctionComponent } from "react";
import RatingPartners from "/src/ui/challengeRating/RatingPartners";
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from "react-i18next";

interface RatingHeaderData {
    partners: string[]
}

const RatingHeader: FunctionComponent<RatingHeaderData> = ({partners}) => {
    const { t } = useTranslation()
    const classes = useStyles()
    return (
        <>
            <h2 className={classes.rating}>{`${t('rating')} S10`}</h2>
            <RatingPartners
                partners={partners}
            />
        </>
    )
}

const useStyles = makeStyles((muiTheme) => ({
    container: {
        fontWeight: 500
    },
    rating: {
        fontSize: '1.25rem',
        margin: '1.5rem 1.5rem 1rem'
    }
}))

export default RatingHeader